import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components";
import Contacts from "../components/Contacts";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { allUSersRoute, host } from "../utils/APIroutes";
import Welcome from "../components/Welcome";
import ChatContainer from "../components/ChatContainer";
import { io } from "socket.io-client";
import {RxCross1} from 'react-icons/rx'

import Button from "react-bootstrap/Button";
import Offcanvas from "react-bootstrap/Offcanvas";

const Chat = () => {
  const socket = useRef();
  const navigate = useNavigate();
  const [contacts, setContacts] = useState([]);
  const [currentUser, setCurrentUser] = useState(undefined);
  const [currentChat, setCurrentChat] = useState(undefined);
  const [isLoaded, setIsLoaded] = useState(false);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    const searchCurrentUser = async () => {
      if (!localStorage.getItem("chat-app-user")) {
        navigate("/login");
      } else {
        const getUser = await JSON.parse(localStorage.getItem("chat-app-user"));
        setCurrentUser(getUser);
        setIsLoaded(true);
      }
    };
    searchCurrentUser();
  }, []);

  useEffect(() => {
    if (currentUser) {
      socket.current = io(host);
      socket.current.emit("add-user", currentUser._id);
    }
  }, [currentUser]);

  useEffect(() => {
    if (currentUser) {
      if (currentUser.isAvatarImageSet) {
        const getContacts = async () => {
          const data = await axios.get(`${allUSersRoute}/${currentUser._id}`);
          setContacts(data.data);
        };
        getContacts();
      } else {
        navigate("/setavatar");
      }
    }
  }, [currentUser]);

  const handleChatChange = (chat) => {
    setCurrentChat(chat);
  };

  return (
    <Container>
      <div className="container">
        <Button variant="primary" onClick={handleShow} className="sidebarBtn">
          Contacts
        </Button>

        <Offcanvas show={show} onHide={handleClose}>
          <button onClick={handleClose} className="sideBarCloseBtn">
          <RxCross1/>
          </button>
          <Contacts
            contacts={contacts}
            currentUser={currentUser}
            changeChat={handleChatChange}
            handleClose={handleClose}
          />
        </Offcanvas>

        <Contacts
          contacts={contacts}
          currentUser={currentUser}
          changeChat={handleChatChange}
        />

        {isLoaded && currentChat === undefined ? (
          <Welcome currentUser={currentUser} />
        ) : (
          <ChatContainer
            currentChat={currentChat}
            currentUser={currentUser}
            socket={socket}
          />
        )}
      </div>
    </Container>
  );
};

const Container = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 1rem;
  align-items: center;
  background-color: #131324;
  .container {
    padding: 0 !important;
    height: 84vh;
    width: 85vw;
    background-color: #00000076;
    display: grid;
    grid-template-columns: 25% 75%;
    .sidebarBtn {
      display: none;
      background-color: #672b68;
      border:none;
      outline: none;
    }

    @media screen and (max-width: 1280px) {
      grid-template-columns: 30%, 70%;
    }

    @media screen and (max-width: 1080px) {
      grid-template-columns: 0% 100%;
      .sidebarBtn {
        display: block;
      }
    }
    @media screen and (max-width: 460px) {
      margin-top:35px !important;
      .sidebarBtn {
        top:77px;
        left:33px;
        padding:5px 8px !important;
      }
    }
  }

`;

export default Chat;
